import * as React from 'react';
import styled from 'styled-components';

import { ShowCheckbox } from '@process-advisor/process-miner/slicers/variants/showCheckbox';
import { SingleBlock } from '@process-advisor/process-miner/slicers/variants/singleBlock';
import { Section } from '@process-advisor/process-miner/slicers/variants/section';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { StepWidth } from '@process-advisor/process-miner/slicers/variants/stepWidth'
import { Highlight } from '@process-advisor/process-miner/slicers/variants/highlight';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

const WrapperCB = styled.div`
    display: flex;
    flex-direction: row;
`;

 export const VisualizerOptions = ({app})  =>  {

    return (
    <Wrapper>
        <SingleBlock width="20%">
            <Section title='Highlight Steps'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <Highlight/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Step Width'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <StepWidth/>
        </SingleBlock>
        <SingleBlock width="19%">
            <Section title={'Filter'}/>
        </SingleBlock>
        <SingleBlock width="81%">
            <WrapperCB>
                <ShowCheckbox
                    label='Loops'
                    update={apiProvider.updateVariantFilterLoops}
                />
            </WrapperCB>
        </SingleBlock>
        <AlertMessage/>
    </Wrapper>
 )};
